import { render, staticRenderFns } from "./RecordsPage.vue?vue&type=template&id=13b9d147&scoped=true&"
import script from "./RecordsPage.vue?vue&type=script&lang=js&"
export * from "./RecordsPage.vue?vue&type=script&lang=js&"
import style0 from "./RecordsPage.vue?vue&type=style&index=0&id=13b9d147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9d147",
  null
  
)

export default component.exports